<template>
  <div class="app">
	  <hrhsCard :list="lists"></hrhsCard>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import{httpAction,getAction,putAction} from "@/api/manage"
import { Toast,Picker } from 'vant'
import hrhsCard from '../common/hrhs-card'
export default {
	components:{hrhsCard},
	data(){
		return{
			title:"向代表留言",
			checked: false,
			checked2:false,
			btn_show:false,
			nav_title:"",
			text:"",
			lists:['','',''],
			id:"",
			columns:[]
		}
	},
	mounted() {
		// this.init()
	},
	methods:{
		init(){
			let params = {id:""}
			params.id = this.$route.query.id
			this.id = this.$route.query.id
			console.log("id",params.id);
			getAction("/akpc/deputiesmanage/query/by/id/for/list",params).then(res=>{
				console.log("res",res);
				if(res.code==200){
					this.list = res.result[0]
				}
				console.log("list",this.list);
				
			})
		},
		goPage(){
			let params = {id:1}
			this.$router.push({
				path:"/hmhq/zyzx_ly",
				query:params
			})
		}
	}
}
</script>

<style scoped lang="less">
.app{
	width: 100%;
	height: 100vh;
	background-color: #f6f7f9;
}
p{
	margin: 0px;
	padding: 0px;
}
input{
	border: none
}
.content{
	padding: 20px 10px;
	font-size: 16px;
	box-sizing: border-box;
	&-nav{
		width: 100%;
		border-radius: 4px;
		background: white;
		margin-bottom: 16px;
		&-card{
			padding: 10px 20px;
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;
			>div:first-child{
				width: 24%;
				height: 80px;
				border: 1px solid #f5f5f5;
				img{
					width: 100%;
					height: 100%;
				}
			}
			>div:last-child{
				width: 64%;
				>div{
					display: flex;
				}
				h3{
					font-size: 18px;
					margin: 0px 12px 0px 0px;
				}
				p{
					font-size: 12px;
					margin: 10px 0px;
				}
				span{
					border-radius: 4px;
					text-align: center;
					display: block;
					line-height: 16px;
					padding: 2px 6px;
					border: 1px solid #0099ff;
					background-color: #e6f5ff;
					color: #0099ff;
					font-size: 12px;
				}
			}
		}
	}
}
</style>